/* eslint-disable max-len */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { handleAcademicRecordsFilterdata } from "../../../CommonMethods/academicReportFilterdata"

const user = JSON.parse(localStorage.getItem('user'));
const initial = user ? true : false;
const initialState = {
    loading:false,
    error:'',
    common:{},
    CognitoGroup:[]
    
}

  
export const GetCommonData = createAsyncThunk('commondata', async ({id, academic_year, selectedclass}) =>  handleAcademicRecordsFilterdata(id, academic_year, selectedclass))

            
const CommonSlice = createSlice({

    name: 'CommonData',
    initialState,
    reducers: {
        handleDropDownValues:(state,action)=>{
            state=action.payload
        },
        handleGroup:(state,action)=>{
            state.CognitoGroup=action.payload
        },
        handleClear:(state,action)=>{
            state.loading=false;
            state.error='';
            state.common={};
            state.CognitoGroup=[];
        }
    

    },
    extraReducers: {
        // register user
        [GetCommonData.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [GetCommonData.fulfilled]: (state, action) => {
            state.loading = false;
            state.common=action.payload
        },
        [GetCommonData.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const {handleDropDownValues,handleGroup,handleClear } = CommonSlice.actions;
export default CommonSlice.reducer